import netcoServer from '../../apis/netcoServer';
import {GET_LOGS} from "../types";
import tableLoadingCall from '../helpers/tableLoadingCall';
import handleBase64FileResponse from "../helpers/handleBase64ZipResponse";

const getLogs= (formValues, page=1, pageSize=10, sidx=null, sord=null, returnString = true) => async (dispatch) => {
  if(!formValues)
    formValues={};
  formValues.returnString = returnString;
  formValues.limit = pageSize;
  formValues.skip = (page - 1) * pageSize;
  formValues.sidx = sidx;
  formValues.sord = sord ? renderSord(sord) : '';
  if (returnString) {
    await tableLoadingCall(dispatch, () => netcoServer.newPost('/UserService/getLogs', formValues), GET_LOGS, onSuccessPayload);
  } else {
    let response = await netcoServer.newPost('/UserService/getLogs', formValues);
    handleBase64FileResponse(response.data.result.logs, 'logs.zip');
  }
};

const renderSord = sord => {
  return sord === 'ascend' ? 'asc' : 'desc';
};

const onSuccessPayload = data => {
  return {
    userReportList: {
      kind: 'logs',
      total: data.result.total,
      entries: data.result.logs
    }
  };
};
export default getLogs;